// Weapon pictures for menu cards as data URLs: modular guns use the gunsmith art; the three classic guns get a
// small code-drawn silhouette; the melee slot uses the katana icon.
import type { Item } from '../../../common/src/rules';
import { WEAPONS } from '../../../common/src/data';
import { weaponArt, meleeArt } from '../weapon-art';
import { PALETTE } from '../theme';
import { weaponCanvas } from '../character-art';

const cache = new Map<string, string>();

function classic(g: CanvasRenderingContext2D, kind: string) {
  const sprite=weaponCanvas(kind==='charge'?'coilgun':kind==='smart'?'smg':kind==='melee'?'tanto':'pistol',PALETTE.cyan);
  const scale=Math.min(g.canvas.width/53,(g.canvas.width-12)/sprite.width,(g.canvas.height-8)/sprite.height);
  g.imageSmoothingEnabled=false;g.drawImage(sprite,(g.canvas.width-sprite.width*scale)/2,(g.canvas.height-sprite.height*scale)/2,sprite.width*scale,sprite.height*scale);
}

/** The always-ready melee slot (null) and the neon tanto: 48 px grid drawn at 4x. */
function meleeIcon(kind: 'katana' | 'tanto'): string {
  const hit = cache.get(kind); if (hit) return hit;
  const cv = document.createElement('canvas'); cv.width = cv.height = 192; meleeArt(cv, kind);
  const url = cv.toDataURL(); cache.set(kind, url); return url;
}

export function weaponUrl(it: Item | null | undefined): string {
  if (!it || it.w === 'fists') return meleeIcon('katana');
  if (it.w === 'tanto') return meleeIcon('tanto');
  const key = it.uid + it.r + (it.b ? JSON.stringify(it.b) : '');
  const hit = cache.get(key); if (hit) return hit;
  const cv = document.createElement('canvas'); cv.width = 240; cv.height = 72;
  if (!weaponArt(cv, it)) classic(cv.getContext('2d')!, WEAPONS[it.w as keyof typeof WEAPONS]?.kind ?? 'ballistic');
  const url = cv.toDataURL(); cache.set(key, url); return url;
}
export const weaponImg = (it: Item | null | undefined, cls = 'mn-wimg') => `<img class="${cls} ${it ? '' : 'fist'}" alt="" src="${weaponUrl(it)}">`;
